<template>
  <div class="tw-p-16">
    <h6>Pick 3 keywords of interests</h6>
    <div class="tw-flex tw-flex-wrap tw-my-5">
      <button v-for="interest in interests" class="btn btn-rounded tw-mr-4 tw-mb-4"
              @click="toggleInterest(interest)"
              :disabled="selectedInterestIds.length === 3 && !isSelected(interest)"
              :class="{ 'btn-primary': isSelected(interest), 'btn-outline-primary !tw-border-gray-300 !tw-text-gray-500 hover:!tw-text-white disabled:hover:!tw-text-gray-500': !isSelected(interest) }">
        {{ interest.name }}
      </button>
    </div>

    <div class="tw-flex tw-justify-end tw-mt-5">
      <button class="btn btn-primary btn-rounded" @click="saveInterests">Done</button>
    </div>

  </div>
</template>

<script>
import GeneralMixins from "../../../mixins/GeneralMixins.js";
import {UsersApi} from "../../Api/UsersApi.js";

export default {
  mixins: [GeneralMixins],

  data() {
    return {
      interests: [],
      selectedInterestIds: []
    }
  },

  mounted() {
    UsersApi.getGlobalInterests().then(response => {
      this.interests = response
      return UsersApi.getInterestIds()
    }).then(response => {
      this.selectedInterestIds = response
    }).catch(error => {
      this.showErrorToast(this.getErrorMessages(error, true))
    })
  },

  methods: {
    toggleInterest(interest) {
      if (this.isSelected(interest)) {
        this.selectedInterestIds = this.selectedInterestIds.filter(id => id !== interest.id)
      } else {
        this.selectedInterestIds.push(interest.id)
      }
    },

    isSelected(interest) {
      return this.selectedInterestIds.includes(interest.id)
    },

    saveInterests() {
      if (this.selectedInterestIds.length !== 3) {
        return this.showErrorToast("Please select 3 keyword interests")
      }

      return UsersApi.saveInterestIds(this.selectedInterestIds).then(() => {
        this.$emit('saved')
      }).catch(error => {
        this.showErrorToast(this.getErrorMessages(error, true))
      })
    }
  }
}
</script>
